import React from "react";
import { FC } from "react";
import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from "video.js";
import "video.js/dist/video-js.css";

export interface VideoPlayerProps {
    options: videojs.PlayerOptions;
    onReady: (player: VideoJsPlayer) => void
}

export const VideoPlayer: FC<VideoPlayerProps> = (props) => {

    const videoRef = React.useRef<HTMLVideoElement>(null);
    const playerRef = React.useRef<VideoJsPlayer | null>(null);
    const { options, onReady } = props;

    React.useEffect(() => {
        const videoOptions: VideoJsPlayerOptions = {
            controls: true,
            responsive: true,
            fluid: true, // deixa a qualidade do video proporcional ao seu tamanho
            aspectRatio: '16:9',
            ...options,
        }

        // make sure Video.js player is only initialized once
        if (!playerRef.current) {
            const videoElement = videoRef.current;
            if (!videoElement) return;

            const player = playerRef.current = videojs(videoElement, videoOptions, () => {
                onReady && onReady(player);
            });
        } else {
            // you can update player here [update player through props]
            // const player = playerRef.current;
            // player.autoplay(videoOptions.autoplay);
            // player.src(videoOptions.sources);
        }
    }, [onReady, options, videoRef]);

    // Dispose the Video.js player when the functional component unmounts
    React.useEffect(() => {
        const player = playerRef.current;

        return () => {
            if (player) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    return (
        <div data-vjs-player>
            <video ref={videoRef} className="video-js vjs-big-play-centered" />
        </div>
    );
}

export default VideoPlayer;
